// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchInput_searchContainer__TAgp3","searchIcon":"SearchInput_searchIcon__aRSfw","searchInput":"SearchInput_searchInput__Ojm-E"};